/* La Cochera — tienda minimalista (11/10/2026). Sin librerías (salvo Three.js, que carga solo el visor 3D cuando se ve).
   Lee window.LCM (lo arma tienda.py: precios, variantes, cupo). En Shopify el carrito es el de Shopify (/cart/*.js) y se paga
   en su checkout; en el sitio estático es un carrito de prueba guardado en el navegador. */
(() => {
  const L = window.LCM || { productos: {} };
  const $ = (s, c = document) => c.querySelector(s), $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const plata = n => '$' + Math.round(n).toLocaleString('es-AR');
  const evento = (n, d = {}) => { try { window.fbq && fbq('trackCustom', n, d) } catch {} };
  const ses = { get: k => { try { return sessionStorage.getItem(k) } catch { return null } }, set: (k, v) => { try { sessionStorage.setItem(k, v) } catch {} } };
  const toast = (() => { const t = $('[data-toast]'); let h; return m => { if (!t) return; t.textContent = m; t.classList.add('on'); clearTimeout(h); h = setTimeout(() => t.classList.remove('on'), 2800) } })();
  const P = L.productos;
  const claveDeHandle = h => Object.keys(P).find(k => (P[k].url || '').endsWith('/' + h));

  // ---------------------------------------------------------------- cabecera, menú, avisos
  const cab = $('[data-cab]');
  const alScroll = () => cab && cab.classList.toggle('solida', scrollY > 30);
  addEventListener('scroll', alScroll, { passive: true }); alScroll();
  const menuBtn = $('[data-menu]'), menu = $('#menu');
  menuBtn?.addEventListener('click', () => { const a = menu.classList.toggle('abierto'); menuBtn.setAttribute('aria-expanded', a); menuBtn.textContent = a ? 'Cerrar' : 'Menú' });
  $$('#menu a').forEach(a => { a.addEventListener('click', () => { menu.classList.remove('abierto'); menuBtn && (menuBtn.textContent = 'Menú') }); if (a.href === location.href.split('#')[0] || a.pathname === location.pathname && a.search === location.search && !a.hash) a.setAttribute('aria-current', 'page') });   // con ?view=… la ruta es «/» para todas: se compara también la búsqueda
  const avisos = $$('[data-avisos] .aviso');
  if (avisos.length > 1 && !quieto) { let i = 0; setInterval(() => { avisos[i].classList.remove('on'); i = (i + 1) % avisos.length; avisos[i].classList.add('on') }, 4200) }

  // ---------------------------------------------------------------- entradas (una vez, escalonadas por hermanos)
  const io = new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('visto'); io.unobserve(e.target) } }), { rootMargin: '0px 0px -8% 0px' });
  $$('[data-aparece]').forEach(el => { const hs = [...el.parentElement.children].filter(x => x.hasAttribute('data-aparece')); el.style.setProperty('--i', Math.min(6, hs.indexOf(el))); io.observe(el) });
  setTimeout(() => $$('[data-aparece]:not(.visto)').forEach(el => { if (el.getBoundingClientRect().top < innerHeight) el.classList.add('visto') }), 1500);

  // ---------------------------------------------------------------- videos: se cargan y se reproducen solo en pantalla
  const ioV = new IntersectionObserver(es => es.forEach(({ target: v, isIntersecting: si }) => {
    if (si) { if (!v.src && v.dataset.src) v.src = v.dataset.src; if (!quieto) v.play().catch(() => {}) } else v.pause();
  }), { rootMargin: '200px 0px', threshold: .15 });
  $$('video[data-src]').forEach(v => ioV.observe(v));
  const hero = $('[data-hero]');
  if (hero && !quieto) {
    hero.src = innerWidth > 760 ? hero.dataset.ancho : hero.dataset.alto;
    hero.addEventListener('playing', () => hero.classList.add('listo'), { once: true });
    hero.play().catch(() => {});
    new IntersectionObserver(([e]) => e.isIntersecting ? hero.play().catch(() => {}) : hero.pause()).observe(hero);
  }

  // ---------------------------------------------------------------- precios derivados: cuotas y cupo
  $$('[data-cuotas]').forEach(s => { const n = +s.dataset.cuotas; if (n) s.textContent = `3 cuotas de ${plata(Math.ceil(n / 3))}` });
  const cupo = L.cupo || {};
  if (cupo.quedan != null && cupo.total) $$('[data-cupo]').forEach(c => {
    const q = Math.max(0, cupo.quedan);
    $('[data-cupo-txt]', c).textContent = q > 0 ? `Quedan ${q} de ${cupo.total} packs a precio de lanzamiento. Después, ${plata(L.listaPack)}.` : `Se terminaron los ${cupo.total} packs de lanzamiento.`;
    const bar = $('span', c); bar.hidden = false; requestAnimationFrame(() => $('[data-cupo-i]', c).style.width = (q / cupo.total * 100) + '%');
  });

  // ---------------------------------------------------------------- eco del anuncio: la ficha sigue la conversación del anuncio
  const qs = new URLSearchParams(location.search);
  if (qs.get('utm_content')) ses.set('lcm_utm', qs.get('utm_content'));
  const eco = $('[data-eco]'), cod = ses.get('lcm_utm');
  if (eco && cod) {
    try {
      const d = JSON.parse(eco.dataset.eco)[cod];
      if (d) { eco.innerHTML = ''; const p = (c, t) => { const x = document.createElement('p'); x.className = c; x.textContent = t; return x }; eco.append(p('eco-c', `«${d[0]}»`), p('eco-r', d[2])); eco.hidden = false }
    } catch {}
  }

  // ---------------------------------------------------------------- WhatsApp con mensaje según la página
  const nombrePag = document.body.dataset.producto ? (P[document.body.dataset.producto]?.nombre || '') : '';
  $$('[data-wa]').forEach(a => { a.href = `https://wa.me/${L.wa || ''}?text=${encodeURIComponent(nombrePag ? `Hola! Tengo una duda sobre ${nombrePag}` : 'Hola! Tengo una consulta sobre La Cochera')}` });

  // ---------------------------------------------------------------- carrito (Shopify o de prueba)
  const LOCAL = 'lcm_carrito';
  const local = () => { try { return JSON.parse(localStorage.getItem(LOCAL)) || [] } catch { return [] } };
  const guardar = c => { try { localStorage.setItem(LOCAL, JSON.stringify(c)) } catch {} };
  const api = L.shopify ? {
    async leer() {
      const c = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      return { items: c.items.map(i => ({ key: i.key, clave: claveDeHandle(i.handle), nombre: i.product_title, sub: i.variant_title && i.variant_title !== 'Default Title' ? i.variant_title : '',
        img: i.image ? i.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2') : '', url: i.url, cant: i.quantity, linea: i.final_line_price / 100 })), total: c.total_price / 100, n: c.item_count };
    },
    async sumar(clave, cant) {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: P[clave].variante, quantity: cant }] }) });
      if (!r.ok) throw new Error((await r.json()).description || 'No se pudo agregar');
    },
    async cambiar(key, cant) { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: cant }) }) },
  } : {
    async leer() {
      const items = local().filter(i => P[i.clave]).map(i => ({ key: i.clave, clave: i.clave, nombre: P[i.clave].nombre, sub: '', img: P[i.clave].img, url: P[i.clave].url, cant: i.cant, linea: P[i.clave].precio * i.cant }));
      return { items, total: items.reduce((s, i) => s + i.linea, 0), n: items.reduce((s, i) => s + i.cant, 0) };
    },
    async sumar(clave, cant) { const c = local(); const i = c.find(x => x.clave === clave); i ? i.cant += cant : c.push({ clave, cant }); guardar(c) },
    async cambiar(key, cant) { guardar(local().map(i => i.clave === key ? { ...i, cant } : i).filter(i => i.cant > 0)) },
  };

  const cajon = $('[data-cajon]'), velo = $('[data-velo]');
  const abrir = () => { cajon?.classList.add('on'); velo?.classList.add('on'); cajon?.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; $('[data-cerrar-carrito]', cajon)?.focus({ preventScroll: true }) };
  const cerrar = () => { cajon?.classList.remove('on'); velo?.classList.remove('on'); cajon?.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = '' };
  $$('[data-abrir-carrito]').forEach(b => b.addEventListener('click', () => { pintar().then(abrir) }));
  $$('[data-cerrar-carrito]').forEach(b => b.addEventListener('click', cerrar));
  velo?.addEventListener('click', cerrar);
  addEventListener('keydown', e => { if (e.key === 'Escape') cerrar() });

  const itemHTML = i => `<div class="item" data-key="${i.key}">
      <a href="${i.url}"><img src="${i.img}" alt="" loading="lazy"></a>
      <div><a class="item-nom" href="${i.url}">${i.nombre}</a>${i.sub ? `<p class="item-sub">${i.sub}</p>` : ''}
        <div class="cant"><button type="button" data-c="-1" aria-label="Uno menos">−</button><span>${i.cant}</span><button type="button" data-c="1" aria-label="Uno más">+</button></div></div>
      <div class="item-der"><b>${plata(i.linea)}</b><button type="button" class="item-quitar" data-quitar>Quitar</button></div>
    </div>`;
  async function pintar() {
    let c;
    try { c = await api.leer() } catch { return }
    $$('[data-cuenta]').forEach(n => { n.textContent = c.n; n.toggleAttribute('data-cero', !c.n) });
    const tienePack = c.items.some(i => i.clave === 'pack');
    const gratis = L.envioGratis || 65000, falta = gratis - c.total;
    $$('[data-envio]').forEach(b => {
      b.hidden = !c.n;
      $('[data-envio-txt]', b).innerHTML = tienePack || falta <= 0 ? '<b>Tenés envío gratis</b> a todo el país.' : `Te faltan <b>${plata(falta)}</b> para el envío gratis.`;
      requestAnimationFrame(() => $('[data-envio-i]', b).style.width = (tienePack ? 100 : Math.min(100, c.total / gratis * 100)) + '%');
    });
    $$('[data-sugiere]').forEach(s => {
      const pk = P.pack; s.hidden = !c.n || tienePack || !pk;
      if (!s.hidden) s.innerHTML = `<img src="${pk.img}" alt=""><div><b>Pack de lanzamiento</b>Los tres, la manopla y el paño por ${plata(pk.precio)}, con envío gratis.</div><button type="button" data-agregar="pack">Sumar</button>`;
    });
    $$('[data-subtotal]').forEach(s => s.textContent = plata(c.total));
    $$('[data-cuota-total]').forEach(s => s.textContent = c.total ? `o 3 cuotas sin interés de ${plata(Math.ceil(c.total / 3))}` : '');
    const vacio = `<div class="cajon-vacio"><p>Tu carrito está vacío.</p><a class="btn" href="${P.pack?.url || '#'}">Ver el pack de lanzamiento</a></div>`;
    $$('[data-items],[data-items-pag]').forEach(cont => cont.innerHTML = c.items.length ? c.items.map(itemHTML).join('') : vacio);
    $$('[data-cajon-pie]').forEach(p => p.hidden = !c.n);
    $$('[data-carro-pag] .carro-res').forEach(r => r.hidden = !c.n);
    enlazar(document);
    return c;
  }
  // cantidades y quitar dentro del carrito
  document.addEventListener('click', async e => {
    const it = e.target.closest('.item'); if (!it) return;
    const key = it.dataset.key, cant = +$('.cant span', it).textContent;
    if (e.target.closest('[data-quitar]')) { it.classList.add('sale'); await new Promise(r => setTimeout(r, 280)); await api.cambiar(key, 0); pintar() }
    else if (e.target.closest('[data-c]')) { await api.cambiar(key, Math.max(0, cant + +e.target.closest('[data-c]').dataset.c)); pintar() }
  });
  $$('[data-pagar]').forEach(a => a.addEventListener('click', e => { if (!L.shopify) { e.preventDefault(); toast('En la tienda, este botón te lleva al pago de Shopify (Mercado Pago).') } }));

  // agregar al carrito / comprar ahora
  function enlazar(raiz) {
    $$('[data-agregar]', raiz).forEach(b => {
      if (b._ok) return; b._ok = true;
      b.addEventListener('click', async () => {
        const clave = b.dataset.agregar, caja = b.closest('[data-caja]');
        const cant = caja ? +($('[data-cant] span', caja)?.textContent || 1) : 1;
        b.setAttribute('aria-busy', 'true');
        try { await api.sumar(clave, cant) } catch (err) { toast(err.message || 'No se pudo agregar. Probá de nuevo.'); b.removeAttribute('aria-busy'); return }
        b.removeAttribute('aria-busy');
        if (b.hasAttribute('data-directo')) {
          if (L.shopify) { location.href = '/checkout'; return }
          toast('En la tienda, «Comprar» te lleva directo al pago.');
        }
        b.classList.add('agregado'); setTimeout(() => b.classList.remove('agregado'), 1600);
        $$('.bolsa').forEach(x => { x.classList.add('salto'); setTimeout(() => x.classList.remove('salto'), 350) });
        await pintar(); if (!b.closest('[data-cajon]')) setTimeout(abrir, b.classList.contains('tile-mas') ? 250 : 450);
      });
    });
  }
  enlazar(document);
  $$('[data-cant]').forEach(c => {
    const n = $('span', c);
    $('[data-menos]', c)?.addEventListener('click', () => n.textContent = Math.max(1, +n.textContent - 1));
    $('[data-mas]', c)?.addEventListener('click', () => n.textContent = Math.min(9, +n.textContent + 1));
  });
  pintar();
  addEventListener('pageshow', e => { if (e.persisted) pintar() });

  // ---------------------------------------------------------------- barra fija del celular (fichas)
  const fija = $('[data-fija]'), ancla = $('[data-ancla-fija]');
  // como en la tienda anterior (08/10): está desde que entrás y se va solo mientras se ve la caja de compra
  if (fija && ancla) new IntersectionObserver(([e]) => fija.classList.toggle('on', !e.isIntersecting)).observe(ancla);

  // ---------------------------------------------------------------- fotos de la ficha: carrusel en el celular, con puntos que se tocan
  const media = $('[data-media]'), puntos = $$('[data-puntos] button');
  if (media && puntos.length) {
    media.addEventListener('scroll', () => { const i = Math.round(media.scrollLeft / media.clientWidth); puntos.forEach((p, k) => p.classList.toggle('on', k === i)) }, { passive: true });
    puntos.forEach((p, k) => p.addEventListener('click', () => media.scrollTo({ left: k * media.clientWidth, behavior: quieto ? 'auto' : 'smooth' })));
  }

  // ---------------------------------------------------------------- visor 3D (arte real de la serigrafía) con respaldo de cuadros
  // Compu: el 3D se arma cuando el visor está a la vista y la página ya cargó (no compite con la foto principal). Pantalla
  // táctil: el visor es la primera foto del carrusel; hasta que se toca «Girar 360°», deslizar pasa de foto, y recién con ese
  // toque se baja Three.js y las texturas (~700 KB que no necesita quien solo mira la foto).
  const tactil = matchMedia('(pointer:coarse)').matches;
  function secuencia(el, n) {
    // sin WebGL: 72 cuadros renderizados del mismo modelo, se arrastran
    const N = 72, base = `${L.seq}${n}/`, img = $('.visor-respaldo', el); let f = 0, x0 = null; const cache = [];
    for (let k = 1; k <= N; k++) { const im = new Image(); im.src = `${base}${String(k).padStart(2, '0')}.jpg`; cache.push(im) }
    const ver = () => { const k = ((Math.round(f) % N) + N) % N; if (cache[k].complete && cache[k].naturalWidth) img.src = cache[k].src };   // un cuadro que no cargó no reemplaza al que se ve
    el.addEventListener('pointerdown', e => { if (tactil && !el.classList.contains('girando')) return; x0 = e.clientX; el.setPointerCapture(e.pointerId); el.classList.add('tocado') });
    el.addEventListener('pointermove', e => { if (x0 === null) return; f -= (e.clientX - x0) / Math.max(4, el.clientWidth / N * 1.4); x0 = e.clientX; ver() });
    el.addEventListener('pointerup', () => x0 = null); el.addEventListener('pointercancel', () => x0 = null);
  }
  const montarVisor = el => el._montado || (el._montado = (async () => {
    const n = el.dataset.visor;
    try {
      const { montar } = await import(L.envase3d);
      const v = montar(el, { producto: n, base: L.tex, fondo: '#dcd5ce', interactivo: true, auto: !quieto, alListo: () => el.classList.add('con-3d') });
      if (!v) throw new Error('sin WebGL');
    } catch { secuencia(el, n) }
  })());
  $$('[data-visor]').forEach(el => {
    const n = el.dataset.visor, btn = $('[data-visor-btn]', el);
    const visto = () => { if (!el.classList.contains('tocado')) { el.classList.add('tocado'); evento('Ver360', { producto: n }) } };
    el.addEventListener('envase-girar', visto);
    btn?.addEventListener('click', async () => {
      const on = !el.classList.contains('girando');
      if (on) { btn.setAttribute('aria-busy', 'true'); await montarVisor(el); btn.removeAttribute('aria-busy'); visto() }
      el.classList.toggle('girando', on); btn.setAttribute('aria-pressed', on); btn.textContent = on ? 'Listo' : 'Girar 360°';
    });
    if (!tactil) {
      // no se espera a «load»: en Shopify llega tarde (scripts de terceros); alcanza con que el navegador esté libre
      const ir = () => new IntersectionObserver(([e], o) => { if (e.isIntersecting) { o.disconnect(); montarVisor(el) } }, { rootMargin: '200px' }).observe(el);
      'requestIdleCallback' in window ? requestIdleCallback(ir, { timeout: 1500 }) : setTimeout(ir, 600);
    }
  });

  // ---------------------------------------------------------------- tira de pasos de la guía (inicio): flechas en compu
  $$('[data-tira]').forEach(t => {
    const marco = t.parentElement, ant = $('[data-tira-ant]', marco), sig = $('[data-tira-sig]', marco);
    const salto = () => ($('li', t)?.offsetWidth || 300) * 2;
    const estado = () => { if (ant) ant.disabled = t.scrollLeft < 8; if (sig) sig.disabled = t.scrollLeft + t.clientWidth > t.scrollWidth - 8 };
    ant?.addEventListener('click', () => t.scrollBy({ left: -salto(), behavior: quieto ? 'auto' : 'smooth' }));
    sig?.addEventListener('click', () => t.scrollBy({ left: salto(), behavior: quieto ? 'auto' : 'smooth' }));
    t.addEventListener('scroll', estado, { passive: true }); addEventListener('resize', estado); estado();
  });

  // ---------------------------------------------------------------- un link a algo plegado (#terminos, #privacidad) lo abre
  const abrirAncla = () => {
    let id = ''; try { id = decodeURIComponent(location.hash.slice(1)) } catch {}
    const d = id && document.getElementById(id);
    if (d && d.tagName === 'DETAILS') { d.open = true; setTimeout(() => d.scrollIntoView({ block: 'start', behavior: 'auto' }), 80) }
  };
  addEventListener('hashchange', abrirAncla); abrirAncla();

  // ---------------------------------------------------------------- comparadores antes / después
  $$('[data-comp]').forEach(c => {
    const r = $('input', c); let tocado = false;
    const fijar = p => { c.style.setProperty('--pos', p + '%'); r.value = p };
    const marcar = () => { if (!tocado) { tocado = true; evento('AntesDespues', { zona: c.dataset.que }) } };
    r.addEventListener('input', () => { fijar(r.value); marcar() });
    c.addEventListener('pointerdown', e => { const b = c.getBoundingClientRect(); fijar(Math.round((e.clientX - b.left) / b.width * 100)); marcar() });
    if (!quieto) new IntersectionObserver(([e], o) => {
      if (!e.isIntersecting) return; o.disconnect(); const t0 = performance.now();
      const paso = t => { if (tocado) return; const p = Math.min(1, (t - t0) / 1600); fijar(50 + Math.sin(p * Math.PI * 2) * 16); if (p < 1) requestAnimationFrame(paso) };
      setTimeout(() => requestAnimationFrame(paso), 350);
    }, { threshold: .6 }).observe(c);
  });

  // ---------------------------------------------------------------- calculadora de dilución del 01
  const calc = $('[data-calc]');
  if (calc) {
    const txt = $('[data-calc-txt]', calc), vaso = $('[data-vaso-p]', calc);
    const elegir = b => {
      $$('[data-dil]').forEach(x => x.setAttribute('aria-pressed', x === b));
      const n = +b.dataset.dil, prod = Math.round(500 / (n + 1));
      txt.innerHTML = `<b>${prod} mL de 01</b>y ${500 - prod} mL de agua, para ${b.dataset.zona}, en un pulverizador de 500 mL. Un envase te alcanza para ${n + 1} pulverizadores.`;
      vaso.style.height = Math.max(4, prod / 500 * 100) + '%';
    };
    $$('[data-dil]').forEach(b => b.addEventListener('click', () => elegir(b)));
    const primero = $('[data-dil]'); if (primero) elegir(primero);
  }

  // ---------------------------------------------------------------- búsqueda (sugerencias mientras escribís)
  const dlg = $('[data-busqueda]'), q = $('[data-q]'), res = $('[data-q-res]');
  $$('[data-abrir-busqueda]').forEach(b => b.addEventListener('click', () => { dlg?.showModal(); setTimeout(() => q?.focus(), 30) }));
  $$('[data-cerrar-busqueda]').forEach(b => b.addEventListener('click', () => dlg?.close()));
  dlg?.addEventListener('click', e => { if (e.target === dlg) dlg.close() });
  let tq;
  q?.addEventListener('input', () => {
    clearTimeout(tq); const t = q.value.trim();
    if (!t) { res.innerHTML = ''; return }
    tq = setTimeout(async () => {
      let hits = [];
      if (L.shopify) {
        try {
          const j = await (await fetch(`/search/suggest.json?q=${encodeURIComponent(t)}&resources[type]=product&resources[limit]=4`)).json();
          hits = (j.resources?.results?.products || []).map(p => ({ nombre: p.title, url: p.url, img: p.image, precio: +p.price }));
        } catch {}
      } else {
        const tn = t.toLowerCase();
        hits = Object.values(P).filter(p => (p.nombre + ' llantas motor plásticos cubiertas carrocería shampoo').toLowerCase().includes(tn)).map(p => ({ nombre: p.nombre, url: p.url, img: p.img, precio: p.precio }));
      }
      res.innerHTML = hits.length ? `<div class="grilla g3">${hits.map(h => `<article class="tile"><a class="tile-foto" href="${h.url}"><img class="a" src="${h.img}" alt=""></a><div class="tile-txt"><div class="tile-fila"><h3><a href="${h.url}">${h.nombre}</a></h3><p class="tile-precio">${plata(h.precio)}</p></div></div></article>`).join('')}</div>`
        : `<p class="vacio">No encontramos «${t.replace(/[<>&]/g, '')}». Son tres productos y un pack.</p>`;
    }, 180);
  });

  // ---------------------------------------------------------------- formularios: código de arrepentimiento y versiones de prueba
  const codigo = () => 'ARR-' + Date.now().toString(36).toUpperCase().slice(-6);
  $$('form[data-tipo="Arrepentimiento"]').forEach(f => f.addEventListener('submit', () => { const c = codigo(); const h = $('[data-codigo]', f); if (h) h.value = c; ses.set('lcm_arr', c) }));
  $$('[data-codigo-ver]').forEach(b => b.textContent = ses.get('lcm_arr') || '');
  $$('[data-form-ok]').forEach(m => m.scrollIntoView({ block: 'center' }));
  $$('form[data-form-demo]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const arr = f.dataset.tipo === 'Arrepentimiento', c = arr ? codigo() : '';
    const ok = document.createElement('p'); ok.className = 'form-ok';
    ok.innerHTML = arr ? `Recibimos tu pedido de arrepentimiento. Tu código de trámite: <b>${c}</b>. En la tienda, esto llega al mail de La Cochera.` : 'Recibimos tu consulta. En la tienda, esto llega al mail de La Cochera.';
    f.replaceWith(ok);
  }));
  $$('[data-alta-demo]').forEach(f => f.addEventListener('submit', e => { e.preventDefault(); toast('Listo. En la tienda, esto te anota en las novedades por mail.'); f.reset() }));
})();
